define('viewmodels/pages/games/search',['knockout', 'underscore'], function (ko, _) {



    function Search(allGames) {
        var self = this;

        self.query = ko.observable();
        self.rateLimitedQuery  = ko.computed(function() {
            return self.query() || '';
        }).extend({ rateLimit: { method: 'notifyWhenChangesStop', timeout: 200 } });

        self.games = allGames.filter(function(game) {
            var query = self.rateLimitedQuery().trim();
            if (query === '') {
                return [];
            }
            query = query.toLowerCase();

            return _.some(game.searchTerms(), function(term) {
                return term.indexOf(query) !== -1;
            });
        }).extend({ rateLimit: 0 });
    }

    var SearchGames = function(gamesBrowser, tabs, getField) {
        var self = this,
            gamesTosearch = ko.deferredComputedArray(function(){

                var allGamesContainer = gamesBrowser.getCategoryById('all')();

                if(!allGamesContainer){
                    return [];
                }

                return allGamesContainer.games();
            });

        self.search = new Search(gamesTosearch);
        self.query = self.search.query;
        self.meta = {
            title: getField('meta_title'),
            description: getField('meta_description')
        };
        self.results = self.search.games;
        self.isSearching = ko.pureComputed(function(){
            var query = self.query();
            if(query && query !== ''){
                return true;
            }
            return false;
        });
        self.prompt = getField('input_prompt');
        self.clearQuery = function(){
            self.query('');
        };
        this.subNav = tabs;
    };

    return SearchGames;
});

